import React from "react"
import {formatTextTestIds} from "@next/utils"
import {TextModel} from "models/Text"
import {
    StyledSelectedFacetsContainer,
    StyledSelectedFacetsTitle,
    StyledSelectedFacetsList,
    RemoveSelectedFacet,
    StyledSelectedFacetLabel,
    StyledList,
    StyledListItem,
    StyledRemoveContainer,
    StyledRemove,
} from "./components"
import FacetsButton from "../facetsButton"
import {FacetState} from "../../models/FacetsState"
import connect from "./connect"
import {useRemoveFilterLabel} from "./useRemoveFilter"

export type SelectedFacetsProps = {
    title: string
    selectedFacets: FacetState[]
    onClearFacets: (event: React.MouseEvent<HTMLButtonElement>) => void
    selectFacet: (facetValue: string) => void
    text: TextModel
}

export const SelectedFacets = ({title, selectedFacets, selectFacet, onClearFacets, text}: SelectedFacetsProps) => {
    const {showRemoveLabel, setRemoveLabel, clearRemoveLabel} = useRemoveFilterLabel(selectFacet)

    return (
        <StyledSelectedFacetsContainer>
            <StyledSelectedFacetsTitle variant="h5" component="h2" id="plp-modal-description">
                {text.pages.viewAllModal.selected} {title}
            </StyledSelectedFacetsTitle>
            {selectedFacets.length > 0 && <FacetsButton text={text.buttons.clear} onClick={onClearFacets} />}
            <StyledSelectedFacetsList>
                <StyledList>
                    {selectedFacets.map(facet => {
                        const {v, n} = facet
                        const hideRemoveLabel = !showRemoveLabel[v]?.focus && !showRemoveLabel[v]?.mouse
                        return (
                            <StyledListItem key={v}>
                                <StyledSelectedFacetLabel
                                    data-testid={formatTextTestIds(`facet-${v}`)}
                                    variant="h6"
                                    component="p"
                                >
                                    {n}
                                </StyledSelectedFacetLabel>
                                <StyledRemoveContainer>
                                    <StyledRemove
                                        data-testid={formatTextTestIds(`remove-text-${v}`)}
                                        id={formatTextTestIds(`remove-text-${v}`)}
                                        aria-hidden={hideRemoveLabel}
                                        $hideLabel={hideRemoveLabel}
                                    >
                                        {text.pages.viewAllModal.remove}
                                    </StyledRemove>
                                    <RemoveSelectedFacet
                                        data-testid={formatTextTestIds(`remove-button-${v}`)}
                                        onMouseOver={setRemoveLabel(v, "mouse", true)}
                                        onMouseOut={setRemoveLabel(v, "mouse", false)}
                                        onFocus={setRemoveLabel(v, "focus", true)}
                                        onBlur={setRemoveLabel(v, "focus", false)}
                                        onClick={clearRemoveLabel(v, n)}
                                        aria-labelledby={formatTextTestIds(`remove-text-${v}`)}
                                    />
                                </StyledRemoveContainer>
                            </StyledListItem>
                        )
                    })}
                </StyledList>
            </StyledSelectedFacetsList>
        </StyledSelectedFacetsContainer>
    )
}

export default connect(SelectedFacets)
